<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<mat-form-field [ngClass]="{ disabled: disabled || isDisabled }">
	<mat-label>{{ label }}</mat-label>

	<div class="input-container">
		<input
			matInput
			[placeholder]="placeholder"
			[value]="value"
			(input)="onInputChange($event)"
			(blur)="onTouched()"
			[disabled]="disabled || isDisabled"
			[min]="min"
			[max]="max"
			[step]="step"
		/>

		@if (unit) {
			<span class="unit">{{ unit }}</span>
		} @else {
			<span [ngClass]="['icon-' + iconName]"></span>
		}
	</div>

	@if (isInvalid) {
		<mat-hint>{{ customErrorMessage || "Invalid input" }}</mat-hint>
	}
</mat-form-field>
